import Svg, { Path } from 'react-native-svg';
import type { TLabelSymbolProps } from '../../../types/softwareLabelTypes';

export const DateOfManufactureSymbol = ({
  width = 28,
  height = 28,
}: TLabelSymbolProps) => (
  <Svg width={width} height={height} viewBox="28 34 144 132">
    <Path
      d="m135.36 118.66v-82.034h33.408v126.74h-137.53v-44.706l18.981-32.876 16.629 27.978 16.629-27.978 16.629 27.978 16.629-27.978 18.271 31.647"
      fill="none"
      stroke="#000"
      strokeWidth="5"
    />
  </Svg>
);
